import React from "react";
import { DirectLineSenderRole } from "../../../enums/DirectLineSenderRole";
import { Stack } from "@fluentui/react";
import { defaultMiddlewareLocalizedTexts } from "../../../../common/defaultProps/defaultMiddlewareLocalizedTexts";
import { defaultTimestampContentStyles } from "../defaultStyles/defaultTimestampContentStyles";
import { getTimestampHourMinute } from "../../../../../../common/utils";
import { useChatContextStore } from "../../../../../..";

/* eslint @typescript-eslint/no-explicit-any: "off" */
export const DeliveredTimestamp = _ref => {
  var _state$domainStates$r, _state$domainStates$r2, _state$domainStates$m;
  let {
    args,
    role,
    name
  } = _ref;
  const [state] = useChatContextStore();
  const dir = ((_state$domainStates$r = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r === void 0 ? void 0 : _state$domainStates$r.timestampDir) ?? state.domainStates.globalDir;
  const contentStyles = {
    ...defaultTimestampContentStyles,
    ...((_state$domainStates$r2 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r2 === void 0 ? void 0 : _state$domainStates$r2.timestampContentStyleProps)
  };
  const {
    activity: {
      timestamp
    }
  } = args;
  const getTimeElement = timestamp => {
    const timeString = getTimestampHourMinute(timestamp);
    const isAmPmFormat = timeString.toLowerCase().includes("am") || timeString.toLowerCase().includes("pm");

    // For clients that use languages that are written right-to-left, but still use AM/PM time format, we need to
    // make sure the "rtl" direction doesn't produce "PM 1:23", but remains "1:23 PM"
    if (dir === "rtl" && isAmPmFormat) {
      return /*#__PURE__*/React.createElement("span", {
        dir: "ltr"
      }, getTimestampHourMinute(timestamp));
    }
    return timeString;
  };
  return /*#__PURE__*/React.createElement(Stack, {
    style: contentStyles,
    dir: dir
  }, role === DirectLineSenderRole.Bot && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    dir: dir,
    "aria-hidden": "false"
  }, name, " - ", getTimeElement(timestamp))), role === DirectLineSenderRole.User && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "false",
    dir: dir
  }, " ", getTimeElement(timestamp), " - ", ((_state$domainStates$m = state.domainStates.middlewareLocalizedTexts) === null || _state$domainStates$m === void 0 ? void 0 : _state$domainStates$m.MIDDLEWARE_MESSAGE_DELIVERED) ?? defaultMiddlewareLocalizedTexts.MIDDLEWARE_MESSAGE_DELIVERED)));
};